interface ISiteElementScrollConfig {
    height: number;
    delay: number;
}

class SiteElementScroll
    extends QueryElement<HTMLElement> {

    private _config: ISiteElementScrollConfig;
    private _rows: number;
    private _container: IQueryElement;
    private _button_more: IQueryElement;
    private _button_prev: IQueryElement;
    private _button_next: IQueryElement;
    private _currentRow: number;
    private _timer?: number;

    constructor(element: HTMLElement) {
        super(element, false);

        this._config = QueryJSON.deserialize<ISiteElementScrollConfig>(this.getAttr("data-config") || "{}");

        var container = this.query(".element-scroll-container").first();
        var button_more = this.query(".element-scroll-more").first();
        var button_prev = this.query(".element-scroll-prev").first();
        var button_next = this.query(".element-scroll-next").first();

        if (container == null || button_more == null || button_next == null || button_prev == null)
            throw "Can not find elements.";
        
        this._container = container;
        this._button_more = button_more;
        this._button_prev = button_prev;
        this._button_next = button_next;

        this._button_more.on("click", () => this.showAll());
        this._button_prev.on("click", () => this.prevItem());
        this._button_next.on("click", () => this.nextItem());
        
        var position = this._container.position();
        var style = this._container.style();
        if (position == null || style == null)
            throw "Unable to get dimension.";
        
        this._rows = Math.round(position.height / this._config.height);
        style.height = `${this._config.height}px`;

        this._currentRow = 0;

        this.loop();
    }
    loop() {
        if (this._config.delay == 0)
            return;

        window.clearTimeout(this._timer);

        this._timer = window.setTimeout(() => {
            this.nextItem();
            this.loop();
        }, this._config.delay * 1000);
    }

    nextItem() {
        if (this._currentRow == -1)
            return;

        this.loop();

        this._currentRow++;
        if (this._currentRow >= this._rows)
            this._currentRow = 0;

        var style = this._container.style();
        if (style != null)
            style.transform = `translateY(-${this._currentRow * this._config.height}px)`;
    }
    prevItem() {
        if (this._currentRow == -1)
            return;

        this.loop();

        this._currentRow--;
        if (this._currentRow < 0)
            this._currentRow = this._rows - 1;
        
        var style = this._container.style();
        if (style != null)
            style.transform = `translateY(-${this._currentRow * this._config.height}px)`;
    }
    showAll() {
        if (this._currentRow == -1) {
            var style = this._container.style();
            if (style != null) {
                style.transform = `translateY(0)`;
                style.height = `${this._config.height}px`
            }
    
            this._currentRow = 0;
            this.loop();
        }
        else {
            var style = this._container.style();
            if (style != null) {
                style.transform = `translateY(0)`;
                style.height = `${this._rows * this._config.height}px`
            }
    
            this._currentRow = -1;
            window.clearTimeout(this._timer);
        }

    }
}